const encoder = window.btoa
export const createSignature = (...args: (number | string)[]) => encoder(encoder(encoder(args.join('/'))))

const decode = window.atob
export const decodeSignature = (code: string) => decode(decode(decode(code))).split('/')
